/* ---------------------------------------------------------------------
Global Js
Target Browsers: All
------------------------------------------------------------------------ */

var FX = (function (FX, $) {

	/**
	 * Doc Ready
	 */
	$(function () {
		FX.General.init(); // For super general or super short scripts
		FX.ImAHuman.init(); // Enable by default
		//FX.ExternalLinks.init(); // Enable by default
		//FX.Tabs.init(); // Enable by default for site search page
		FX.Social.init(); // Open social share in new windows. Used in single.php by default
		//FX.Menu.init();
		FX.BackToTop.init();
	});

	$(window).on('load', function () {
		// TODO: Uncomment if using smooth scrolling anchors
		// FX.SmoothAnchors.init();
	});

	/**
	 * Example Code Block - This should be removed
	 * @type {Object}
	 */
	FX.CodeBlock = {
		init: function () {

		},
	};

	/**
	 * General functionality — ideal for one-liners or super-duper short code blocks
	 */
	FX.General = {
		init: function () {
			this.bind();
		},

		bind: function () {

			// Makes all PDF to open in new tabs
			$('a[href*=".pdf"]').each(function (e) {
				$(this).attr('target', '_blank');
			});

			// Choices (select field styling) - additional options here https://github.com/jshjohnson/Choices
			const elSelects = document.querySelectorAll('select')
			elSelects.forEach(el => {
				FX.General.setUpChoice(el);
			});

			// pretty-format phone inputs
			$('[type="tel"]').phoneFormat();

			// position: sticky support through polyfill
			var $stickyEls = $('.js-sticky');
			if ($stickyEls.length && typeof (Stickyfill) === 'object')
				Stickyfill($stickyEls);

			// FitVids - responsive videos
			//$('body').fitVids();

			// Input on focus remove placeholder
			$('input,textarea').focus(function () {
				$(this).removeAttr('placeholder');
			});

			// TODO: Add additional small scripts below

            // Get all outer links by class name
          setTimeout(function() {
            var outerLinks = document.getElementsByClassName('fx-yotpo-outer-link');
            
            // Loop through each outer link
            for (var i = 0; i < outerLinks.length; i++) {
              var outerLink = outerLinks[i];
              // Get the URL of the outer link
              var outerUrl = outerLink.getAttribute('href');
              
              // Get the inner link inside the current outer link
              var innerLink = outerLink.getElementsByClassName('text-m')[0];
              
              if (innerLink) {
                // Set the same URL for the inner link
                innerLink.setAttribute('href', outerUrl);
              }
            }
          }, 1000);

          // Check if the URL contains the specified string
          if (window.location.href.indexOf("yotpo-reviews-main-widget") > -1) {
    
              // Define a function to check if the element exists
              function checkElement() {
                  var element = document.getElementById('yotpo-reviews-main-widget');
                  if (element) {
                      // Scroll to the element
                      element.scrollIntoView({ behavior: "smooth", block: "start" });
                    window.scrollTo(0, window.scrollY - 1);
                  } else {
                      // If the element doesn't exist yet, check again after a short delay
                      setTimeout(checkElement, 100);
                  }
              }
      
              // Start checking for the element
              checkElement();
          }
		},

		setUpChoice: function (elSelect) {
			const choice = new Choices(elSelect)
			const form = elSelect.closest('form')

			form.addEventListener('reset', function () {
				choice.destroy(); // destroy old choices instance

				FX.General.setUpChoice(elSelect); // rebuild new choices instance
			}, { once: true });

			if ('cat' === elSelect.id) {
				elSelect.onchange = null

				choice.passedElement.element.addEventListener('change', e => {
					e.target.closest('form').submit()
				})
			}
		}
	};

	/**
	 * Slider/Carousel
	 * @type {Object}
	 */
	FX.SlickSlider = {
		init: function () {
			// Fix flashing issue (first slide initially shown)
			$('.slick-slider').on('init', function (e, slick) {
				$('.slideshow .slide').show();
			});

			/* Preloader */
			$('.js-slider-has-preloader').on('init', function (e, slick) {
				$('.js-slider-has-preloader').addClass('js-slider-has-preloader-init');
			});

			$('.slick-slider').slick({ /* Change class based on slider name */
				/* Add settings here*/
			});

            $('.product-detail__images').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              fade: true
              //asNavFor: '.product-detail__thumbnails'
            });

            $('.product-detail__thumbnails').slick({
              slidesToShow: 4,
              slidesToScroll: 1,
              asNavFor: '.product-detail__images',
              dots: true,
              centerMode: true,
              focusOnSelect: true
            });

		}
	};

	/**
	 * Display scroll-to-top after a certain amount of pixels
	 * @type {Object}
	 */
	FX.BackToTop = {
		$btn: null,

		init: function () {
			this.$btn = $('#back-to-top');
			if (this.$btn.length)
				this.bind();

		},

		bind: function () {
			$(window).on('scroll load', this.maybeShowButton.bind(this));
			this.$btn.on('click', this.scrollToTop);
		},

		maybeShowButton: function () {
			if ($(window).scrollTop() > 100) { // TODO: Update "100" for how far down page to show button
				this.$btn.removeClass('hide');
			} else {
				this.$btn.addClass('hide');
			}
		},

		scrollToTop: function () {
			$(window).scrollTop(0);
			console.log('topclick');
		}
	};

	/**
	 * Mobile menu script for opening/closing menu and sub menus
	 * @type {Object}
	 */
	FX.MobileMenu = {
		init: function () {
			$('.nav-primary li.menu-item-has-children > a').after('<span class="sub-menu-toggle icon-arrow-down hidden-md-up"></span>');
			$('.sub-menu-toggle').click(function () {
				var $this = $(this),
					$parent = $this.closest('li'),
					$wrap = $parent.find('> .sub-menu');
				$wrap.toggleClass('js-toggled');
				$this.toggleClass('js-toggled');
			});
		}
	};

	/**
	 * Ubermenu mobile menu toggle hack
	 * @type {Object}
	 */
	FX.Menu = {
		windowWidth: 0,
		$ubermenu: $('#ubermenu-nav-main-33'), // replace with ID of ubermenu element
		$topLevelMenuItems: null,
		$mobileMenuToggle: $('.ubermenu-responsive-toggle'),


		init: function () {
			this.setMenuClasses();
			this.setSubMenuClasses();

			this.$topLevelMenuItems = this.$ubermenu.children('.ubermenu-item-level-0');
			this.bind();
		},

		setMenuClasses: function () {
			let windowWidth = $(window).innerWidth();
			// iOS fires resize event on scroll - let's first make sure the window width actually changed
			if (windowWidth == this.windowWidth) {
				return;
			}
			this.windowWidth = windowWidth;
			if (this.windowWidth < 1025) {
				$('.ubermenu-item-has-children').each(function () {
					$(this).removeClass('ubermenu-has-submenu-drop');
				});
			} else {
				$('.ubermenu-item-has-children').each(function () {
					$(this).addClass('ubermenu-has-submenu-drop');
				});
			}
		},

		setSubMenuClasses: function () {
			$('.ubermenu-item-has-children').each(function () {
				$(this).children('a').each(function () {
					let $this = $(this);
					$this.children('.ubermenu-sub-indicator').clone().insertAfter($this).addClass('submenu-toggle hidden-md-up');
					$this.children('.ubermenu-sub-indicator').addClass('hidden-sm-down');
				});
			});
		},

		bind: function () {
			$(window).on('resize', this.setMenuClasses.bind(this));

			$('.submenu-toggle').on('touchstart click', this.toggleNextLevel);

			this.$topLevelMenuItems.on('ubermenuopen', this.handleUbermenuOpen.bind(this))
			this.$topLevelMenuItems.on('ubermenuclose', this.handleUbermenuClose.bind(this))

			// when clicking to open/close mobile menu toggle
			this.$mobileMenuToggle.on('ubermenutoggledopen', this.handleUbermenuOpen.bind(this))
			this.$mobileMenuToggle.on('ubermenutoggledclose', this.handleUbermenuClose.bind(this))
		},

		handleUbermenuOpen(e) {
			const self = this,
				$container = self.$ubermenu.closest('.desktop-menu')

			$(document.body).addClass('menu-is-active')
			$container.addClass('menu-is-active')
			self.$mobileMenuToggle.addClass('menu-is-active')
		},


		handleUbermenuClose(e) {
			const self = this,
				$container = self.$ubermenu.closest('.desktop-menu')

			$(document.body).removeClass('menu-is-active')
			$container.removeClass('menu-is-active')
			self.$mobileMenuToggle.removeClass('menu-is-active')
		},



		/* handleResponsiveToggleClick( e ) {
			const $btn = $(e.currentTarget),
				$menu = $('.desktop-menu').find('.ubermenu-main')

			$btn.toggleClass('menu-is-active', $menu.hasClass('ubermenu-responsive-collapse') )
		}, */

		toggleNextLevel: function (event) {
			event.preventDefault();
			let $this = $(this);
			$this.toggleClass('fa-angle-down').toggleClass('fa-times');
			$this.parent().toggleClass('ubermenu-active');
			if ($this.parent().hasClass('ubermenu-active')) {
				$this.parent().siblings('.ubermenu-active').removeClass('ubermenu-active').children('.submenu-toggle').addClass('fa-angle-down').removeClass('fa-times');
			}
		}
	}

	/**
	 * Force External Links to open in new window.
	 * @type {Object}
	 */
	FX.ExternalLinks = {
		init: function () {
			var siteUrlBase = FX.siteurl.replace(/^https?:\/\/((w){3})?/, '');
			$('a[href*="//"]:not([href*="' + siteUrlBase + '"])')
				.not('.ignore-external') // ignore class for excluding
				.addClass('external')
				.attr('target', '_blank')
				.attr('rel', 'noopener');
		}
	};


	/**
	 * Custom Social Share icons open windows
	 * Generate URLs, place in a tag and use class - example: https://github.com/bradvin/social-share-urls
	 * @type {Object}
	 */
	FX.Social = {
		init: function () {
			$('.js-social-share').on('click', this.open);
		},

		open: function (e) {
			e.preventDefault();
			FX.Social.windowPopup($(this).attr('href'), 500, 300);
		},

		windowPopup: function (url, width, height) {
			var left = (screen.width / 2) - (width / 2),
				top = (screen.height / 2) - (height / 2);

			window.open(
				url,
				'',
				'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left
			);
		}
	};

	/**
	 * ImAHuman
	 * Hidden Captchas for forms
	 * @type {Object}
	 */
	FX.ImAHuman = {
		init: function () {
			this.bind();
		},

		bind: function () {
			var self = this,
				$forms = $('form');

			$forms.each(function () {
				$(this).on('focus click', self.markAsHuman);
			});
		},

		markAsHuman: function () {
			$(this).find('.imahuman, [name="imahuman"]').attr('value', parseInt('0xFF9481', 16));
		}
	};


	/**
	 * Affix
	 * Fixes sticky items on scroll
	 * @type {Object}
	 */
	FX.Affix = {
		$body: null,
		$header: null,
		headerHeight: null,
		scrollTimeout: null,
		resizeTimeout: null,

		init: function () {
			this.$body = $(document.body);
			this.$header = $('#page-header');
			this.headerHeight = this.$header.outerHeight(true);

			this.bind();
		},

		bind: function (e) {
			$(window).on('scroll', this.handleScroll.bind(this));
			$(window).on('resize', this.handleResize.bind(this));
		},

		handleScroll: function (e) {
			var self = this;

			// avoid constantly running intensive function(s) on scroll
			if (self.scrollTimeout !== null)
				clearTimeout(self.scrollTimeout);

			setTimeout(function () {
				self.maybeAffixHeader();
			}, 500);
		},

		handleResize: function (e) {
			var self = this;

			// avoid constantly running intensive function(s) on resize
			if (self.resizeTimeout !== null)
				clearTimeout(self.resizeTimeout);

			setTimeout(function () {
				self.headerHeight = self.$header.outerHeight(true);
			}, 500);
		},

		maybeAffixHeader: function () {
			var self = this;

			if (200 < $(window).scrollTop()) {
				self.$body.css('padding-top', self.headerHeight);
				self.$header.addClass('js-scrolled');
			} else {
				self.$body.css('padding-top', 0);
				self.$header.removeClass('js-scrolled');
			}
		}
	};


	/**
	 * FX.Parallax
	 * Parallax effect for images
	 * @type {Object}
	 */
	FX.Parallax = {

		init: function () {
			this.bind();
		},

		bind: function () {
			$(window).scroll(this.scroll);
		},

		scroll: function (e) {
			$('.js-parallax').each(function () {
				var $this = $(this),
					speed = $this.data('speed') || 6,
					yPos = -($(window).scrollTop() / speed),
					coords = 'center  ' + yPos + 'px';

				$this.css({ objectPosition: coords }); /* based on parallax using an object-fit <img> */
			});
		}
	};

	/**
	 * FX.SmoothAnchors
	 * Smoothly Scroll to Anchor ID
	 * @type {Object}
	 */
	FX.SmoothAnchors = {
		init: function () {
			this.hash = window.location.hash;
			if (this.hash != '') {
				this.scrollToSmooth(this.hash);
			}
			this.bind();
		},

		bind: function () {
			$('a[href^="#"]').on('click', $.proxy(this.onClick, this));
		},

		onClick: function (e) {
			e.preventDefault();
			var target = $(e.currentTarget).attr('href');
			this.scrollToSmooth(target);
		},

		scrollToSmooth: function (target) {
			var $target = $(target);
			$target = ($target.length) ? $target : $(this.hash);

			var headerHeight = 0; // TODO: if using sticky header change 0 to
			// $('#page-header').outerHeight(true)

			if ($target.length) {
				var targetOffset = $target.offset().top - headerHeight;
				$('html, body').animate({ scrollTop: targetOffset }, 600);
				return false;
			}
		}
	};

	/**
	 * Tab/Accordion Content
	 * @type {Object}
	 */

	FX.Tabs = {
		init: function () {
			let self = this;
			self.maybeAdjustHeight(); // run on load

			this.bind()
		},

		bind: function () {
			$('.js-tabs').on('click touchstart', 'a', this.switchTab.bind(this));
			$(window).resize(this.maybeAdjustHeight.bind(this));
		},

		switchTab: function (e) {
			e.preventDefault();
			let $this = $(e.currentTarget),
				$tab = $($this.attr('href')),
				self = FX.Tabs;

			$this.parent()
				.addClass('tab-active show')
				.siblings('.js-tabs')
				.removeClass('tab-active show');

			$tab.addClass('tab-active show')
				.siblings('.tab-content')
				.removeClass('tab-active show');

			self.maybeAdjustHeight($this.parent(), $tab)
		},

		/* Used to convert to accordions on mobile */
		maybeAdjustHeight: function ($active_tab, $tab_content) {

			if (typeof $active_tab == 'undefined')
				$active_tab = $('.js-tabs.tab-active');
			if (typeof $tab_content == 'undefined')
				$tab_content = $('.tab-content.tab-active');

			// TODO update according to appropriate screen size for accordion. By default set up for accordions on mobile and tablet.
			let max_accordion_width = 1024;

			if (window.innerWidth > max_accordion_width) {
				let height = $active_tab.outerHeight() + $tab_content.outerHeight();
				$('.accordion-tabs').css('height', (height + 'px'));
			} else {
				$('.accordion-tabs').css('height', '');
			}
		}
	};

	return FX;

}(FX || {}, jQuery));
